"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
var _react = _interopRequireWildcard(require("react"));
var _tkComponentFields = require("@xo-union/tk-component-fields");
var _tkComponentButtons = require("@xo-union/tk-component-buttons");
var _reactCssModules = require("@xo-union/react-css-modules");
var _tkComponentIcons = _interopRequireDefault(require("@xo-union/tk-component-icons"));
var _SearchBarModule = _interopRequireDefault(require("./SearchBar.module.css"));
var _SubNavContext = require("../../context/SubNavContext.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchBarClearButton = _ref => {
  let {
    onClick,
    onKeyDown
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchBarModule.default.clearSearchButton__wrapper,
    "data-testid": "SearchBar__clearButton",
    "aria-label": "clear search",
    role: "button",
    tabIndex: 0,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "close_circle",
    role: "img",
    size: "sm"
  }));
};
const SearchBarSearchButton = _ref2 => {
  let {
    onClickHandlerSearchButton,
    doesSearchFieldHasValue
  } = _ref2;
  const {
    tenant
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const searchButtonClassOverrides = (0, _reactCssModules.compose)({
    'animated-element': tenant === 'tk' ? '' : _SearchBarModule.default.searchBarButton__animated__ww
  });
  const searchButtonStyles = [_SearchBarModule.default.searchBarButton];
  return /*#__PURE__*/_react.default.createElement(_tkComponentButtons.Button, {
    "aria-label": "Search",
    size: 'md',
    "data-testid": "SearchBar__searchButton",
    className: searchButtonStyles.join(' '),
    onClick: onClickHandlerSearchButton,
    disabled: !doesSearchFieldHasValue,
    classes: searchButtonClassOverrides
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "search",
    size: "md"
  }));
};
const buildSearchFieldClassOverrides = () => {
  const searchBarInputContainerStyles = [_SearchBarModule.default.searchBar__inputContainer];
  return (0, _reactCssModules.compose)({
    container: searchBarInputContainerStyles.join(' '),
    label: _SearchBarModule.default.searchField__label
  });
};
const SearchBar = _ref3 => {
  let {
    onSearch,
    placeholder,
    initialSearchTerm = '',
    handleClick,
    shouldFocusSearchBar = false
  } = _ref3;
  const {
    trackProductsSearched,
    trackSearchInitialized
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const [searchTerm, setSearchTerm] = (0, _react.useState)(initialSearchTerm);
  const [hasSearchInitialized, setHasSearchInitialized] = (0, _react.useState)(false);
  const doesSearchFieldHasValue = () => !!(0, _trim.default)(searchTerm).call(searchTerm).length;
  const onClickHandlerClearSearchInput = () => {
    setSearchTerm('');
  };
  const onKeyDownHandlerClearSearchInput = event => {
    if (event.key === 'Enter') {
      setSearchTerm('');
    }
  };
  const onChangeHandlerSearchInput = event => {
    const target = event.target;
    const searchInputValue = target.value;
    setSearchTerm(searchInputValue);
    if (searchInputValue.length > 1 && !hasSearchInitialized) {
      trackSearchInitialized === null || trackSearchInitialized === void 0 || trackSearchInitialized();
      setHasSearchInitialized(true);
    }
  };
  const onKeyDownHandlerSearchInput = event => {
    if (event.key === 'Enter') {
      trackProductsSearched === null || trackProductsSearched === void 0 || trackProductsSearched(searchTerm);
      onSearch(searchTerm);
    }
  };
  const onClickHandlerSearchButton = () => {
    trackProductsSearched === null || trackProductsSearched === void 0 || trackProductsSearched(searchTerm);
    onSearch(searchTerm);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "searchbox",
    className: _SearchBarModule.default.searchBar,
    "aria-label": "main search box",
    "data-testid": "SearchBar"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SearchBarModule.default.searchBar__container
  }, /*#__PURE__*/_react.default.createElement(_tkComponentFields.Field, {
    classes: buildSearchFieldClassOverrides(),
    name: "",
    type: "search",
    onChange: onChangeHandlerSearchInput,
    onKeyDown: onKeyDownHandlerSearchInput,
    value: searchTerm,
    onClick: handleClick,
    id: "products-search-input",
    "data-testid": "SearchBar__input",
    autoComplete: "off",
    placeholder: placeholder,
    autoFocus: shouldFocusSearchBar
  }), doesSearchFieldHasValue() && /*#__PURE__*/_react.default.createElement(SearchBarClearButton, {
    onClick: onClickHandlerClearSearchInput,
    onKeyDown: onKeyDownHandlerClearSearchInput
  })), /*#__PURE__*/_react.default.createElement(SearchBarSearchButton, {
    onClickHandlerSearchButton: onClickHandlerSearchButton,
    doesSearchFieldHasValue: doesSearchFieldHasValue()
  }));
};
var _default = exports.default = SearchBar;